// extracted by mini-css-extract-plugin
export default {"message":"AiMessage_message__53db+"};